import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Client } from '../../../../../lib/components/client/classes/client';
import { VvvoDetailsComponent } from '../vvvo-details/vvvo-details.component';

@Component({
    selector: 'kiene-vvvodetails-dialog',
    templateUrl: './vvvodetails-dialog.component.html',
    styleUrls: ['./vvvodetails-dialog.component.scss'],
})
export class VVVODetailsDialogComponent implements OnInit {
    @ViewChild('vvvoDetailsComp') vvvoDetailsComp?: VvvoDetailsComponent;
    kunde: Client;
    emailRequired = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<VVVODetailsDialogComponent>,
    ) {
        this.kunde = data?.kunde || data?.client || data;
        if (typeof data?.emailRequired === 'boolean') {
            this.emailRequired = data.emailRequired;
        }
    }

    ngOnInit(): void {}

    public saveInDialog(): void {
        this.vvvoDetailsComp?.updateKunde();
    }
}
